module.exports = __webpack_public_path__ + "img/workplan-questions.jpg?61870ccc50f008b9e19fcf830fed9687";